import { useState } from "react";
import styles from "./AdminSwitchUserForm.module.scss";
import { ApiAuth } from "@/shared/api/auth/api-auth";
import { useToastStore } from "@/shared/stores/toastStore";
import { useQueryClient } from "@tanstack/react-query";
import { useAuthStore } from "@/shared/stores/authStore";
import { useSuppliersStore } from "@/shared/stores/suppliersStore";

interface AdminSwitchUserFormProps {
  isOpen: boolean;
  onClose: () => void;
}

export function AdminSwitchUserForm({
  isOpen,
  onClose,
}: AdminSwitchUserFormProps) {
  const [userId, setUserId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { showToast } = useToastStore();
  const queryClient = useQueryClient();
  const { refetchProfile } = useAuthStore();
  const { fetchSuppliers } = useSuppliersStore();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const authApi = new ApiAuth();
      await authApi.loginAsUser(userId);

      localStorage.removeItem("seller-alert-selected-person");

      await refetchProfile();
      await fetchSuppliers();
      await queryClient.invalidateQueries();
      showToast("Переключение успешно.", "success");

      onClose();
    } catch (error) {
      showToast("Ошибка при переключении пользователя", "error");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <h3 className={styles.title}>Смена пользователя</h3>
          <button onClick={onClose} className={styles.closeButton}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
        <form onSubmit={handleSubmit} className={styles.form}>
          <p>Введите ID пользователя для переключения:</p>
          <input
            type="text"
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
            placeholder="User ID"
            className={styles.input}
            disabled={isLoading}
          />
          <button
            type="submit"
            className={styles.submitButton}
            disabled={isLoading || !userId}
          >
            {isLoading ? "Переключение..." : "Переключиться"}
          </button>
        </form>
      </div>
    </div>
  );
}
